import "./NotFound.scss";

function NotFound({ CLOUDFRONT_URL }) {
  return <div className="not-found">404 Page Not Found.</div>;
}

export default NotFound;
